import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Icon feather-plus",
  "use": "icon-Icon feather-plus-usage",
  "viewBox": "0 0 21.5 21.5",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21.5 21.5\" id=\"icon-Icon feather-plus\"><defs><style>#icon-Icon feather-plus .a{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}</style></defs><g transform=\"translate(-6.75 -6.75)\"><path class=\"a\" d=\"M18,7.5v20\" transform=\"translate(-0.5 0)\" /><path class=\"a\" d=\"M7.5,18h20\" transform=\"translate(0 -0.5)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol